import { useState } from 'react';

import { CheckboxField } from '@nesso/ui/primitives/checkbox-field';
import { TreeNode } from '@nesso/ui/primitives/tree-node';

import { NoteTextarea } from '@/shared/ui/common/note-textarea';

type Props = {
    id?: string;
    label?: string;
    checked: boolean;
    onCheckedChange: (checked: boolean) => void;
    comment?: string;
    onCommentChange: (comment?: string) => void;
};

export function CommentableCheckbox({
    id,
    label = 'Other',
    checked,
    onCheckedChange,
    comment,
    onCommentChange,
}: Props) {
    const [justChecked, setJustChecked] = useState(false);

    const handleCheckedChange = (next: boolean | 'indeterminate') => {
        const isNowChecked = next === true;
        setJustChecked(isNowChecked);
        onCheckedChange(isNowChecked);

        if (!isNowChecked) {
            onCommentChange(undefined);
        }
    };

    return (
        <TreeNode
            open={checked}
            hideSeparator
            triggerAsToggle={false}
            trigger={
                <CheckboxField
                    id={id}
                    label={label}
                    checked={checked}
                    onCheckedChange={handleCheckedChange}
                />
            }
        >
            <NoteTextarea
                autoFocus={justChecked}
                value={comment}
                onChange={(value) => onCommentChange(value || undefined)}
                className="w-full"
            />
        </TreeNode>
    );
}
